import * as React from 'react';

import type { } from '@mui/x-data-grid-pro/themeAugmentation';

import {  useTheme } from '@mui/material';
import { useTranslations } from '@fenetech/translations';
import { useDashboardOrderData } from './useDashboardData';

import  { AddStatusColumnData } from "components/Common/DataGridColumnGenerator";
import { generateOrderColumns } from "./OrdersGridColumns";
import { GridRowIdGetter, GridRowModel } from '@mui/x-data-grid-pro';
import useApplicationInfo from 'helpers/context/Application/useApplicationInfo';
import useIsMobile from 'helpers/hooks/useIsMobile';
import useCurrencyFormatter from "helpers/hooks/useCurrencyFormatter";
import useUserInfo from "helpers/context/User/useUserInfo";
import CustomDataGridPro from "components/Common/CustomDataGridPro";

const OrdersGrid: React.FC<any> = (props: any) => {

    const appInfo = useApplicationInfo();
    const tm = useTranslations();
    const cf = useCurrencyFormatter();
    const theme = useTheme();
    const rawData = useDashboardOrderData();
    const isMobile = useIsMobile();
    const user = useUserInfo();

    const getRowId: GridRowIdGetter = (row: GridRowModel) => {
        return row.oKey;
    }
    
    const data = React.useMemo(() => {
        if (rawData) {
            return rawData.map((o) => AddStatusColumnData(o, "Received", theme, tm));
        } else {
            return null;
        }
    }, [rawData, theme, tm]);

    const columns = React.useMemo(() => {
        return generateOrderColumns(tm, data, theme, appInfo, isMobile, cf, user);
    }, [tm, data, theme, appInfo, isMobile, cf, user]);

    return <>
        <CustomDataGridPro
            rows={data}
            columns={columns}
            getRowId={getRowId}
            tableName="DashboardOrders"
            tableSubName={isMobile ? "Mobile" : ""}
            hideInMobileColumns={[
                "orderDate",
                "totalPrice",
                "reqDate",
                "targetShipDate",
                "mfgSiteName"
            ]}
        />
    </>
};

export default OrdersGrid;